import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PostDto } from "../../../api/interfaces/Posts";
import { useForm } from "react-hook-form";
import { API_ENDPOINTS } from "../../../api";
import { userInfo } from "os";
import { getService, putService } from "../../../servce/ApisService";
import { useLoader } from "../../../Loader/LoaderContext";
import Sucesspopup from "../Modals/SucessPopup";
import { useToaster } from "../../../Toaster/Toaster";

const BookingFormDownload = () => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    clearErrors,
    reset,
    setError,
    formState: { errors, isValid, isSubmitting, touchedFields },
    setFocus,
  } = useForm<PostDto>({
    mode: "onChange",
  });
  const { showToast } = useToaster();
  const navigate = useNavigate();
  const location = useLocation();
  const { setLoading } = useLoader();
  const [isShow, setIsShow] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [file, setFile] = useState<string | null>(null);
  const [submittedData, setSubmittedData] = useState<PostDto | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [formattedSize, setFormattedSize] = useState<string>("");
  const formatFileSize = (size: number): string => {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    return parseFloat((size / Math.pow(1024, i)).toFixed(2)) + " " + sizes[i];
  };

  const queryParams = new URLSearchParams(location.search);
  const bookingId = queryParams.get("bookingId");
  const companyName = queryParams.get("companyName");
  const name = queryParams.get("name");
useEffect(() => {
  console.log("Current URL:", window.location.href);
}, [bookingId]);


  const users = () => {
    if(name ==='reupload'){
      navigate("/portals/bookings/confirmedBooking");
    }else{
      navigate("/portals/bookings/viewBooking");
    }
   
  };
  const usersScreen=()=>{
    navigate(-1)
  }
  const clearFile = () => {
    setFile(null);
  };
  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
    if (selectedFile.type !== "application/pdf") {
      setError("imageDto", {
        type: "manual",
        message: "Only PDF files are allowed.",
      });
      setFile(null); // Clear the file state
      setSelectedFile(null); // Clear the selected file state
      return; // Stop further execution
    }
      const formattedSize = formatFileSize(selectedFile.size);
      setFormattedSize(formattedSize);
      setSelectedFile(selectedFile);
      // Convert the file to a Base64 string
    const preview = await convertToBase64(selectedFile);
    setFile(preview);
    clearErrors("imageDto");
    
    }else {
    // Clear states if no file is selected
    setFile(null);
    setSelectedFile(null);
  }
  };

  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

  const handelUpload= async () => {
    setLoading(true);
    try {
      let url;
     url=API_ENDPOINTS.submitSignedBookingForm
  
      if (url && selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        
        // Constructing LeadBookingFormDto payload as per API requirement
        const payload = {
          bookingId: bookingId,
          fileDto: {
            name: selectedFile?.name,
            type: selectedFile?.type,
            base64Str: file,
          },
        };
        const response = await putService(url, payload);
        if (response.statusCode === 200) {
          setIsShow(true); // Show popup on successful upload
        }
      }
    } catch (error:any) {
      if (error.response?.data?.message === 'Service expiry date exceeded.') {
        showToast(
          'Service end date has expired. Please update and upload the order form to proceed.',
          'error',
          ''
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handelDownloadSignedForm = async (user: any) => {
    let apiUrl = "";
    console.log(user);

    // Function to decode base64 string to an ArrayBuffer (moved outside)
    function base64ToArrayBuffer(base64: string) {
      const binaryString = window.atob(base64); // Decode base64 string
      const len = binaryString.length;
      const bytes = new Uint8Array(len); // Create a Uint8Array from binary string
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i); // Convert each char to binary
      }
      return bytes.buffer;
    }

    // Determine the correct API endpoint based on user roles
    if (userInfo.roles === "SALES_MANAGER") {
      apiUrl = API_ENDPOINTS.salesManagerDownloadBookingForm;
    } else if (userInfo.roles === "SALES_ADMIN") {
      apiUrl = API_ENDPOINTS.salesAdminDownloadBookingForm;
    } else if (userInfo.roles === "SALES_TEAM_LEAD") {
      apiUrl = API_ENDPOINTS.salesTlDownloadBookingForm;
    } else if (userInfo.roles === "SALES_EXECUTIVE") {
      apiUrl = API_ENDPOINTS.salesExecutiveDownloadBookingForm;
    }
    try {
      const response = await getService(`${apiUrl}?bookingId=${bookingId}`);

      // Check if response data exists and contains base64 string
      if (response.data && response.data.base64Str) {
        // Convert the base64 string into a Blob URL for downloading
        const arrayBuffer = base64ToArrayBuffer(response.data.base64Str);
        const downloadUrl = window.URL.createObjectURL(
          new Blob([arrayBuffer], { type: "application/pdf" })
        );

        // Create an anchor element to trigger the download
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", response.data.name || "bookingForm.pdf"); // Set filename
        document.body.appendChild(link);
        link.click();

        // Cleanup: Remove the link and revoke the Blob URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      } else {
        console.error("No valid base64 string found in the response data");
      }
    } catch (error) {
      console.error("Error downloading the order form:", error);
    }
  };

  // Close the popup
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  
  const viewUsers = () => {
    setIsShow(false);
    navigate("/portals/bookings/viewBooking");
  };

  const closePopup = () => {
    setIsShow(false);
    showToast(
      'Upload and Booking Confirmed!',
      'success',
      'Your signed order form has been uploaded successfully, and your services are now booked and confirmed.',7000
    );
    setTimeout(() => {
      navigate("/portals/bookings/confirmedBooking");
      window.location.reload();
    }, 2000);
  };

  return (
    <div className="h-full py-2 w-full">
      <div className="flex items-center cursor-pointer mb-4 font-Inter">
        <h2
          className="mr-2 text-gray-700 font-semibold text-sm"
          onClick={users}
        >
          {name ==='reupload' ? 'Confirmed' : 'Booked' }  
        </h2>
        <img src="/images/arrowIcons.svg" className="mr-2" />
        <h2 className="mr-2 text-[#9CA3AF] font-semibold text-sm">
          Upload Signed Order Form
        </h2>
      </div>
      <div
        className="flex gap-2 items-center  pb-7 cursor-pointer"
        onClick={users}
      >
        <img src="/images/Back or Arrow left (1).svg" />
        <p className="text-[#2D2E2F] font-bold text-2xl">
          Upload Signed Order Form for {companyName}
        </p>
      </div>
      <div className="bg-white w-auto h-[70vh] p-6 rounded-[8px]">
        <div className="gap-3 pb-7 font-Inter">
          {/* <p className="text-sm font-semibold text-gray-700 pb-1">
            Upload Signed Booking Form
          </p> */}
          <p className="text-xs font-normal text-gray-700 mb-[10px]">
          Please upload a signed copy of the order form.
          </p>
          <div className="relative">
            {!file && !submittedData?.imageDto?.documentUrl && (
              <div className="border-dashed border-2 border-gray-300 p-6 rounded-md text-center bg-[#FF56770A]">
                <label className="cursor-pointer">
                  <div className="flex justify-center mb-2">
                    <input
                      type="file"
                      accept=".pdf"
                      onChange={handleFileChange}
                      ref={fileInputRef}
                      className=" hidden w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-red-50 file:text-red-700 hover:file:bg-red-100"
                    />
                    <img src="/images/uploadImgIcon.svg" />
                  </div>
                  <p className="font-semibold text-sm">
                    <span className="text-[#B00A2B]">Upload a file</span>{" "}
                    <span className="text-gray-700">or drag and drop</span>
                  </p>
                  <p className="text-xs text-gray-500 font-normal mt-2">
                  Formats: PDF, JPG up to 3MB
                  </p>
                  
                </label>
              </div>
            )}
            {(file || submittedData?.imageDto) && (
              <div className="mt-1 border border-[#E7E7E7] p-4 flex items-center justify-between rounded">
                <div className="flex items-center">
                  <img src="/images/pdf.svg" className="w-[35px] h-[35px] mr-2"/>
                  <div>
                    <h2 className="text-[#0B0B0B] font-semibold text-xs">
                      {selectedFile?.name
                        ? selectedFile?.name
                        : submittedData?.imageDto?.name}
                    </h2>
                    <p className="text-[#6D6D6D] text-sm font-normal">
                      {formattedSize}
                    </p>
                  </div>
                </div>
                <div className="flex items-center cursor-pointer">
                  {/* Refresh image that triggers file input */}
                  <span className="relative w-[50%] cursor-pointer">
                    <img
                      onClick={() => fileInputRef.current?.click()}
                      // onClick={reUploadFile}
                      src="/images/refresh.svg"
                      alt="Refresh"
                      className="max-w-xs mr-3 cursor-pointer"
                    />
                    {/* Hidden file input (within the div but does not interfere with the delete image) */}
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      ref={fileInputRef}
                      // className="hidden"
                      className="absolute top-0 left-0 w-full h-full hidden cursor-pointer"
                      // style={{ zIndex: 2 }}
                      onClick={(e) => e.stopPropagation()} // Prevent event from bubbling up to parent elements
                    />
                  </span>
                  <span className="w-[50%]">
                    <img
                      onClick={clearFile}
                      src="/images/delete.svg"
                      alt="Delete"
                      className="max-w-xs cursor-pointer"
                    />
                  </span>
                </div>
              </div>
            )}
            {errors.imageDto && (
              <p className="text-[#B91C1C] text-normal mt-2">
                {errors.imageDto.message}
              </p>
            )}
          </div>
          {!(file || submittedData?.imageDto?.documentUrl) && (
          <div>
          <p className="pt-8 text-sm font-semibold text-gray-700">
            Download Unsigned Order Form
          </p>
          <p className="text-xs font-normal pt-1 text-gray-700 pb-3">
            Don't have the signed Order form yet? Click here to download the
            unsigned form, fill it out, and upload the signed copy once
            completed.
          </p>
          <div className="flex bg-[#FFF8FA] py-3 px-6 w-32 rounded-[4px] cursor-pointer">
            <img src="/images/download arrow.svg" />
            <p className="text-[#B91C1C] text-xs font-semibold pl-2"
            onClick={handelDownloadSignedForm}>
              Download
            </p>
          </div>
          </div>
          )}
        </div>
        <div className="fixed bottom-[28px] w-[80%] ml-[-24px] mr-[26px]">
          <div
            className="flex justify-end  p-4 items-center  bg-white bottom-[20px]"
            style={{
              boxShadow: "0px -16px 50px 0px #0000000D",
            }}
          >
            <button
              type="submit"
              className={`px-4 py-2 border border-gray-300 text-gray-600  rounded-[8px] font-bold text-base mr-3`}
              onClick={usersScreen}
            >
              Cancel
            </button>
            <button
              type="submit"
              onClick={handelUpload}
              // disabled={!isValid || isSubmitting || isBollen}
              className={`px-4 py-2 gradient-background text-white rounded-[8px] font-bold text-base `}
            >
              Upload
            </button>
          </div>
        </div>
      </div>
      {isShow && (
        <Sucesspopup
          confirm={closePopup}
          upload={viewUsers}
          // emailId={submittedData?.email || ""}
          // isUpdate={userId ? "update" : "add"}
          nameOfScreen="upload"
          statusValue={submittedData?.status || ""}
          download={function (): void {
            throw new Error("Function not implemented.");
          } } isUpdate={""} addUser={function (): void {
            throw new Error("Function not implemented.");
          } } viewUser={function (): void {
            throw new Error("Function not implemented.");
          } }        />
      )}
    </div>
  );
};

export default BookingFormDownload;
